import React from "react";
import { Grid } from "@material-ui/core";
import { Link } from "react-router-dom";
import "./cardCircularProgressBarHL.css";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { useMediaQuery } from "@material-ui/core";

const CardCircularProgressBarHLPure = (props) => {
  const {
    url, // url card
    text, //text card
    text2, // second text card
    valueChart, //value to progressBar
    classForContainer, //Insert a class for the progress_bar container
    stylesForCirclebar, //Styles to define height and width for the circular bar
    fontClass, //Styles for the font in the text
    horizontalCard, //Styles for horizontal card settings
    stylesForText, //Styles for the horizontal card
    displayStyles, //Display styles for a different order in the items
    styleMobile, // True to use mobile style as default, align horizontal
  } = props;

  const mobileResolution = useMediaQuery("(max-width:414px)");

  return (
    <>
      {styleMobile !== true ? (
        <Link to={url}>
          <Grid
            item
            xs={12}
            lg={12}
            md={12}
            sm={12}
            className={
              classForContainer
                ? classForContainer
                : "circleProgressBar-containerOriginalSquare"
            }
          >
            <Grid className="circleProgressBar-card">
              <CircularProgressbar
                value={valueChart}
                className={"circleProgressBar-styleSquare"}
              />
            </Grid>
            <Grid className="circleProgressBar-descriptionSquare">
              <p
                className={
                  fontClass ? fontClass : "circleProgressBar-textSquare"
                }
              >
                {text}
              </p>
              <p className="circleProgressBar-porcentSquare">{text2}</p>
            </Grid>
          </Grid>
        </Link>
      ) : (
        <Link to={url}>
          <Grid
            item
            xs={12}
            lg={12}
            md={12}
            sm={12}
            className={
              classForContainer
                ? classForContainer
                : "cardCircularProgressBarHL-containerHorizontal"
            }
          >
            <Grid className="cardCircularProgressBarHL-descriptionHorizontal">
              <p
                className={
                  fontClass
                    ? fontClass
                    : "cardCircularProgressBarHL-textHorizontal"
                }
              >
                {text}
              </p>
              <p className="cardCircularProgressBarHL-porcentHorizontal ">
                {text2}
              </p>
            </Grid>
            <Grid className="circleProgressBar-card">
              <CircularProgressbar
                value={valueChart}
                className={
                  stylesForCirclebar
                    ? stylesForCirclebar
                    : "cardCircularProgressBarHL-circleHorizontal"
                }
              />
            </Grid>
          </Grid>
        </Link>
      )}
      {/* {mobileResolution === true ? (
        // <Swiper modules={[EffectFade]} effect="fade">
        //   <SwiperSlide className={"circularProgressBar-swiperSlide"}>
        <Link to={url}>
          <Grid
            item
            xs={12}
            lg={12}
            md={12}
            sm={12}
            className={
              classForContainer
                ? classForContainer
                : "circularProgressBar-container"
            }
          >
            <Grid className="circleProgressBar-card">
              <CircularProgressbar
                value={valueChart}
                className={"circleProgressBar-style"}
              />
            </Grid>
            <Grid className="cardSpinner-description">
              <p className={fontClass ? fontClass : "circularProgressBar-text"}>
                {text}
              </p>
              <p className="cardSpinner-porcent">{text2}</p>
            </Grid>
          </Grid>
        </Link>
      ) : (
        //   </SwiperSlide>
        // </Swiper>
        <>
          {!horizontalCard ? (
            <Link to={url}>
              <Grid
                item
                xs={12}
                lg={12}
                md={12}
                sm={12}
                className={
                  classForContainer
                    ? classForContainer
                    : "circularProgressBar-container"
                }
              >
                <Grid className="circleProgressBar-container">
                  <CircularProgressbar
                    value={valueChart}
                    className={
                      stylesForCirclebar
                        ? stylesForCirclebar
                        : "circleProgressBar-style"
                    }
                  />
                </Grid>
                <Grid
                  className={fontClass ? fontClass : "cardSpinner-description"}
                >
                  <span>{text}</span>
                  <span className="cardSpinner-porcent">{text2}</span>
                </Grid>
              </Grid>
            </Link>
          ) : (
            <Link to={url}>
              <Grid
                item
                xs={12}
                lg={12}
                md={12}
                sm={12}
                className={
                  classForContainer
                    ? classForContainer
                    : "circularProgressBar-container"
                }
              >
                <Grid
                  className={
                    displayStyles
                      ? displayStyles
                      : "circleProgressBar-container"
                  }
                >
                  <span
                    className={
                      stylesForText
                        ? stylesForText
                        : "cardSpinner-porcent cardSpinner-description"
                    }
                  >
                    {text2}
                  </span>
                  <CircularProgressbar
                    value={valueChart}
                    className={
                      stylesForCirclebar
                        ? stylesForCirclebar
                        : "circleProgressBar-style"
                    }
                  />
                </Grid>
                <Grid
                  className={fontClass ? fontClass : "cardSpinner-description"}
                >
                  <span>{text}</span>
                </Grid>
              </Grid>
            </Link>
          )} */}
      {/* </> */}
      {/* )} */}
    </>
  );
};

export { CardCircularProgressBarHLPure as default };
